export const startupTranslation = {
  new_case_header: 7434,
  new_case_description: 7433,
  new_case_register: 5328,

  open_case_header: 8298,
  open_case_description: 8317,
  open_case_case_no: 8299,
  open_case: 8300
};
